var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"错误详情","visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('pre',[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }